import { makeRequest } from "./api";

export const FetchRoles = async (page, limit) => {
  return makeRequest(`/api/admin/roles/fetch?page=${page}&limit=${limit}`);
};

export const FetchPrivileges = async () => {
  return makeRequest("/api/admin/roles/permissions");
};

export const UpdateRole = async (role) => {
  return makeRequest("/api/admin/roles/update", {
    method: "PUT",
    data: {
      ...role,
      roleId: role._id,
    },
  });
};

export const CreateRole = async (role) => {
  return makeRequest("/api/admin/roles/create", {
    method: "POST",
    data: {
      ...role,
      roleId: role._id,
    },
  });
};

export const DeleteRole = async (roleId) => {
  return makeRequest(`/api/admin/roles/delete/${roleId}`, {
    method: "DELETE",
  });
};
